import React, { useEffect, useContext, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setExerciseWords,
  setFalseTranslations,
  fetchUserVocabulary,
  generateWordSignedUrls,
} from "../../../redux/slices/userVocabularySlice";
import MultipleChoiceCard from "./MultipleChoiceCard";
import { UserContext } from "../../user/UserContext";
import { Container, Col } from "react-bootstrap";

export default function TranslationToWord() {
  const dispatch = useDispatch(); // Initialize the Redux dispatch function
  const { userAttributes } = useContext(UserContext); // Access user attributes from context
  const { userWords, exerciseWords, falseTranslations, loading } = useSelector(
    (state) => state.userVocabulary
  ); // Access relevant state from the Redux store
  const wordsSignedUrls = useSelector(
    (state) => state.userVocabulary.wordsSignedUrls
  ); // Get the signed URLs for the words images

  // Fetch user vocabulary if it hasn't been loaded yet
  useEffect(() => {
    if (userWords.length === 0 && !loading) {
      const loadData = async () => {
        try {
          const response = await dispatch(
            fetchUserVocabulary({ owner: userAttributes.sub })
          );
          if (response.payload && response.payload.items) {
            console.log("Words fetched:", response.payload.items);
            // Generate signed URLs for the word images
            await dispatch(generateWordSignedUrls(response.payload.items));
          }
        } catch (error) {
          console.error("Error in loadData:", error);
        }
      };
      loadData(); // Trigger the async function
    }
  }, [dispatch, userAttributes.sub, userWords.length, loading]);

  const prepareNewExercise = useCallback(() => {
    if (userWords.length > 0) {
      // Sort words by progress in ascending order and select the first 5 words
      const WordsToTrain = [...userWords]
        .sort((a, b) => a.progress - b.progress) // Sort words by progress ascending
        .slice(0, 5); // Select the first 5 words with the lowest progress

      // Select 20 random words for the multiple choice options
      const FalseTranslations = [...userWords]
        .sort(() => 0.5 - Math.random()) // Shuffle the remaining words
        .slice(0, 20); // Select 20 words for false options

      dispatch(setExerciseWords(WordsToTrain)); // Set the exercise words in the Redux store
      dispatch(
        setFalseTranslations(FalseTranslations.map((w) => w.word)) // Set the false words in the Redux store
      );
    }
  }, [userWords, dispatch]);

  // Prepare exercise words and false translations initially
  useEffect(() => {
    prepareNewExercise();
  }, [prepareNewExercise]);

  // Show a loading message while vocabulary is being fetched
  if (loading) {
    return (
      <Container>
        <Col className="d-flex align-items-center justify-content-center pt-2">
          <p>Loading vocabulary...</p>
        </Col>
      </Container>
    );
  }

  // Show a message if no words are available for the exercise
  if (exerciseWords.length === 0) {
    return <p>No words available for exercise.</p>;
  }

  // Render the multiple choice exercise component
  return (
    <>
      <MultipleChoiceCard
        exerciseWords={exerciseWords}
        wordsSignedUrls={wordsSignedUrls}
        falseTranslations={falseTranslations}
        onTrainAgain={prepareNewExercise}
        reverse={true}
      />
    </>
  );
}
